module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("… on the one hand, living beings (or substances), and on the other, apparatuses in which living beings are incessantly captured.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('blockquote', {
    staticClass: "quoter"
  }, [_vm._v("Giorgio Agamben, “What Is an Apparatus?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b140985a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Fm01.vue
// module id = 72
// module chunks = 0